import script from "./FormPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./FormPhoneInput.vue?vue&type=style&index=0&id=6548cb39&lang=css"

const __exports__ = script;

export default __exports__